export default __webpack_public_path__ + "static/media/right-background.58abafc5.png";